import { render, staticRenderFns } from "./EMReleaseNotes.vue?vue&type=template&id=34dbd515&scoped=true&"
import script from "./EMReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./EMReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./EMReleaseNotes.vue?vue&type=style&index=0&id=34dbd515&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dbd515",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCardText,VIcon,VSpacer,VToolbar,VToolbarTitle})
